import { AssessmentProposal } from "@/api/generated";
import { PropertyHolder } from "@/view_models/atoms";

// 1ページあたりのプロパティ数
const propertiesPerPage = 6;

// ページネーションのためのロジックを関数に変更
export const calculatePagination = (
  properties: PropertyHolder[],
  currentPage: number
): {
  currentProperties: PropertyHolder[];
  totalPages: number;
} => {
  const indexOfLastProperty = currentPage * propertiesPerPage;
  const indexOfFirstProperty = indexOfLastProperty - propertiesPerPage;
  const currentProperties = properties.slice(indexOfFirstProperty, indexOfLastProperty);

  const totalPages = Math.ceil(properties.length / propertiesPerPage);

  return { currentProperties, totalPages };
};

// オファー
const offersPerPage = 6;

// 投資オファー：ページネーションのためのロジックを関数に変更
export const calculatePaginationInvestmentProposal = <T>(
  investmentProposals: T[],
  currentPage: number,
  perPage = offersPerPage
): {
  currentInvestmentProposals: T[];
  totalPages: number;
} => {
  const indexOfLastProperty = currentPage * perPage;
  const indexOfFirstProperty = indexOfLastProperty - perPage;
  const currentInvestmentProposals = investmentProposals.slice(indexOfFirstProperty, indexOfLastProperty);

  const totalPages = Math.ceil(investmentProposals.length / perPage);

  return { currentInvestmentProposals, totalPages };
};

// 投資オファー：ページネーションのためのロジックを関数に変更
export const calculatePaginationAssessmentProposal = (
  assessmentProposals: AssessmentProposal[],
  currentPage: number
): {
  currentAssessmentProposals: AssessmentProposal[];
  totalPages: number;
} => {
  const indexOfLastProperty = currentPage * offersPerPage;
  const indexOfFirstProperty = indexOfLastProperty - offersPerPage;
  const currentAssessmentProposals = assessmentProposals.slice(indexOfFirstProperty, indexOfLastProperty);

  const totalPages = Math.ceil(assessmentProposals.length / offersPerPage);

  return { currentAssessmentProposals, totalPages };
};
